export default __webpack_public_path__ + "static/media/013-manta ray.29673df0.svg";